<template>
  <v-container fluid class="help">
    <v-row>
      <v-col class="text-center">
        <h1>Proposal Maker</h1>
        <h3>Takaful Pro Essential</h3>
        <br><br><hr><br>
        <!-- image uploader and cropper -->
        <v-col class="mx-lg-auto" cols="12" lg="8">
          <v-file-input
            v-model="image"
            accept="image/png, image/jpeg, image/bmp"
            placeholder="Pick your awesome image"
            :prepend-icon="mdiCamera"
            label="Image"
            :rules="formRules.image"
            @change="imageInputChange()"
            @click:clear="imageCleared()"
          ></v-file-input>
        </v-col>
        <v-row justify="space-around" class="pa-4 mx-lg-auto" v-if="!gocrop" >
          <v-col class="mx-lg-auto" cols="12" lg="8">
            <v-img
              v-bind:src="uploadedImageUrl"
              aspect-ratio="1"
              class="grey lighten-2"
              contain
              height="400"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-icon x-large>{{mdiImage}}</v-icon>
                </v-row>
              </template>
            </v-img>
          </v-col>
          
        </v-row>
        <p class="caption red--text" v-show="!isImgFromLocalStorage && !isImgCropped">IMPORTANT! : Please crop the image first.</p>
        <v-btn @click="gocrop=!gocrop" v-if="!gocrop">Crop</v-btn>
        <br><br>
        <transition class="slide-fade" v-if="gocrop">
          <v-row justify-md="space-around">
            <v-col sm="5" md="6" >
              <v-btn @click="gocrop=!gocrop" color="red" dark class="mx-2">Cancel</v-btn>
              <v-btn @click="crop()" color="green" dark class="mx-2">Done</v-btn>
              <br><br>  
              <cropper
                class="cropper"
                v-bind:src="uploadedImageUrl"
                :stencil-props="{
                  aspectRatio: 1.414/1
                }"
                ref="cropper"
              ></cropper>
              <br>
            </v-col>
          </v-row>
        </transition>
        <br>

        <!-- details form -->
        <v-form 
          ref="form" 
          @submit.prevent="submit">
          <v-container fluid>
              <v-row align="center">  
                <v-col class="mx-lg-auto" cols="12" lg="8">
                  <p>Maklumat Ejen</p>
                    <v-text-field
                        v-model="agentName"
                        :rules="formRules.text"
                        color="blue darken-2"
                        label="Nama"
                        outlined
                        class="text-input"
                    ></v-text-field>
                    <v-text-field
                        v-model="agentTitle"
                        :rules="formRules.text"
                        color="blue darken-2"
                        label="Jawatan"
                        outlined
                        class="text-input"
                    ></v-text-field>
                    <v-text-field
                        v-model="agentPhoneNumber"
                        :rules="formRules.text"
                        color="blue darken-2"
                        label="No Telefon"
                        outlined
                    ></v-text-field>
                    <v-text-field
                        v-model="agentEmail"
                        :rules="formRules.text"
                        color="blue darken-2"
                        label="Email"
                        outlined
                    >
                    </v-text-field>
                </v-col>
                <br><br>

                
                <v-col class="mx-lg-auto" cols="12" lg="8">
                  <p>Maklumat Klien</p>
                    <v-text-field
                      v-model="clientName"
                      :rules="formRules.text"
                      color="blue darken-2"
                      label="Nama"
                      outlined
                      class="text-input"
                    ></v-text-field>
                    <v-text-field
                      v-model="clientAge"
                      :rules="formRules.text"
                      color="blue darken-2"
                      label="Umur"
                      outlined
                    ></v-text-field>
                    <v-select
                      v-model="clientGender"
                      :items="clientGenderItems"
                      :rules="formRules.text"
                      label="Jantina"
                      outlined
                    ></v-select>
                    <v-select
                      v-model="clientIsSmoker"
                      :items="clientIsSmokerItems"
                      :rules="formRules.text"
                      label="Adakah Perokok"
                      outlined
                    ></v-select>
                    
                </v-col>
                <br><br>

                
                <v-col class="mx-lg-auto" cols="12" lg="8">
                  <p>Maklumat Proposal</p>
                    <v-select
                      v-model="docObjective"
                      :items="docObjectiveItems"
                      :rules="formRules.text"
                      label="Objektif"
                      outlined
                    ></v-select>
                    <v-text-field
                        v-model="docTotalProtection"
                        :rules="formRules.text"
                        color="blue darken-2"
                        label="Jumlah Perlindungan"
                        outlined
                    ></v-text-field>
                    <v-text-field
                        v-model="docTotalContributions"
                        :rules="formRules.text"
                        color="blue darken-2"
                        label="Jumlah Caruman"
                        outlined
                    ></v-text-field>
                    <v-text-field
                        v-model="docPaymentMode"
                        :rules="formRules.text"
                        color="blue darken-2"
                        label="Mode Bayaran"
                        outlined
                        class="text-input"
                    >
                    </v-text-field>
                    <v-text-field
                        v-model="docProtectionPeriod"
                        :rules="formRules.text"
                        color="blue darken-2"
                        label="Tempoh Perlindungan"
                        outlined
                    >
                    </v-text-field>
                    <v-text-field
                        v-model="docTotalMature1"
                        :rules="formRules.text"
                        color="blue darken-2"
                        label="Manfaat Sijil Matang 1"
                        outlined
                    >
                    </v-text-field>
                    <v-text-field
                        v-model="docTotalMature2"
                        :rules="formRules.text"
                        color="blue darken-2"
                        label="Manfaat Sijil Matang 2"
                        outlined
                    >
                    </v-text-field>
                </v-col>
                <br><br>

                
                <v-col class="mx-lg-auto" cols="12" lg="8">
                  <p>Maklumat Perlindungan Tambahan (Jika Ada)</p>
                    <v-text-field
                        v-model="docBen1"
                        color="blue darken-2"
                        label="51 Penyakit Kritikal"
                        outlined
                    >
                    </v-text-field>
                    <v-text-field
                        v-model="docBen2"
                        color="blue darken-2"
                        label="Pengecualian Caruman Tahunan"
                        outlined
                    >
                    </v-text-field>
                    <v-text-field
                        v-model="docBen3"
                        color="blue darken-2"
                        label="Kemalangan"
                        outlined
                    >
                    </v-text-field>
                    <v-text-field
                        v-model="docBen4"
                        color="blue darken-2"
                        label="MC Akibat Kemalangan"
                        outlined
                    >
                    </v-text-field>
                    <v-text-field
                        v-model="docBen5"
                        color="blue darken-2"
                        label="Bil Rawatan Akibat Kemalangan"
                        outlined
                    >
                    </v-text-field>
                    <v-text-field
                        v-model="docBen6"
                        color="blue darken-2"
                        label="Elaun Kemasukan Hospital"
                        outlined
                    >
                    </v-text-field>
                    <v-text-field
                        v-model="docBen7"
                        color="blue darken-2"
                        label="Medikal Kad MediPro"
                        outlined
                    >
                    </v-text-field>
                    
                </v-col>
              </v-row>
          </v-container>
          <v-btn
              :disabled="!formIsValid"
              color="primary"
              type="submit"
          >
              Generate
          </v-btn>
        </v-form>
        <br><br>

        <!-- overlay submit form response-->
        <v-overlay :value="overlay">
            <v-card
                class="mx-auto pa-4"
                max-width="344"
                outlined
            > 
                <br>
                <!--
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                <h3 class="title ma-3">Generating contract</h3><p class="sub-title">Will be downloaded automatically.</p>
                -->

                <v-progress-circular
                  :rotate="-90"
                  :size="100"
                  :width="15"
                  :value="progressValue"
                  color="grey lighten-5"
                >
                {{progressValue}}
                </v-progress-circular>
                <br><br>
                <p class="sub-title">{{ progressDetail }}</p>
                
                <v-btn
                  icon
                  @click="overlay = false"
                  x-large
                  
                  >
                  <v-icon>{{mdiClose}}</v-icon>
                  Dismiss
                </v-btn>
            </v-card>
        </v-overlay>


        <!-- dev purpose codes -->
        <!--<v-btn
              color="primary"
              @click="submit2"
          >
              Check Dimensions
          </v-btn>-->
        <!--
        <v-btn          
            color="primary"
            @click="generatePdf"
        >
            Submit
        </v-btn>
        -->
      </v-col>
    </v-row>
    
    
  </v-container>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { getDatabase, ref, push } from "firebase/database";
import { dbPaths } from "../assets/dbPaths.js";
import {  mdiClose, mdiImage, mdiCamera } from '@mdi/js'

export default {
  components: {
    Cropper
  },

  data: () => ({
    //image upload and cropping data.
    uploadedImageUrl: '',
    uploadedImgFromLocalStorage: '',
    image: [],
    gocrop: false,
    cropBtnlabel: 'Crop',
    cropBtnColor: '',
    isCropping: false,
    isImgFromLocalStorage: '',
    isImgCropped: '',

    mdiClose,
    mdiImage,
    mdiCamera,

    coordinates: {
      width: 0,
      height: 0,
      left: 0,
      top: 0,
    },

    //form data.
    agentName: '',
    agentTitle: '',
    agentPhoneNumber: '',
    agentEmail: '',

    clientName: '',
    clientGender: '',
    clientAge: '',
    clientIsSmoker: '',

    clientGenderItems: ['LELAKI', 'PEREMPUAN'],
    clientIsSmokerItems: ['YA', 'TIDAK'],

    docObjectiveItems: ['PENGGANTIAN PENDAPATAN KELUARGA', 'HIBAH @ HADIAH', 'JAMINAN HARTANAH', 'TABUNG PENDIDIKAN ANAK', 'KESINAMBUNGAN PERNIAGAAN', 'KOS PERUBATAN'],
    docObjective: '',
    docTotalProtection: '',
    docTotalContributions: '',
    docPaymentMode: '',
    docProtectionPeriod: '',
    docBen1: '',
    docBen2: '',
    docBen3: '',
    docBen4: '',
    docBen5: '',
    docBen6: '',
    docBen7: '',
    docTotalMature1: '',
    docTotalMature2: '',

    formRules: {
      text: [val => (val || '').length > 0 || 'This field is required'],
      //image: [val => (val) || 'Image is required']
    },

    overlay: false,
    progressValue: 0,
    progressDetail: '',

  }),


  computed: {
    formIsValid () {
      return (
        //this.uploadedImageUrl &&
        this.uploadImageIsValid &&
        this.agentName && this.agentTitle && this.agentPhoneNumber && this.agentEmail && 
        this.clientName && this.clientGender && this.clientAge && this.clientIsSmoker &&
        this.docObjective && this.docTotalProtection && this.docTotalContributions && this.docPaymentMode && this.docProtectionPeriod && this.docTotalMature1 && this.docTotalMature2 
      )
    },

    uploadImageIsValid() {
      return (
        this.isImgFromLocalStorage || this.isImgCropped
      )
      
    }

    //use computed function to return value of isUploadedImageValid, use this var on above function.
    
  },

  methods: {

    //image stuff
    imageInputChange () {
      //console.log('imageInputChange triggered !');
      if (this.image) {
        //image is added. in url format.
        this.uploadedImageUrl = URL.createObjectURL(this.image)
        this.isImgFromLocalStorage = false
        this.isImgCropped = false
        //console.log('image is added : ' + this.uploadedImageUrl);
      } else {
        //image adding is cancelled.
        //console.log('imageInputChange - else triggered.');
        this.uploadedImageUrl = this.uploadedImgFromLocalStorage
        this.isImgFromLocalStorage = true
        this.isImgCropped = false
      }
    },
    imageCleared() {
      //console.log('image input is cleared !');
      
      this.isImgFromLocalStorage = true
      this.isImgCropped = false
    },
    useDefaultImage() {
      this.uploadedImageUrl = this.uploadedImgFromLocalStorage
      this.isImgFromLocalStorage = true
      this.isImgCropped = false
    },
    //change({coordinates, canvas}) {
      //console.log(coordinates, canvas)
    //},
    crop() {
      const { coordinates, canvas, } = this.$refs.cropper.getResult();
      this.coordinates = coordinates;
      // You able to do different manipulations at a canvas
      // but there we just get a cropped image
      this.gocrop = false
      this.uploadedImageUrl = canvas.toDataURL(); //base64 format.
      this.isImgFromLocalStorage = false
      this.isImgCropped = true
      console.log('image is cropped : ' + this.uploadedImageUrl);
    },

    //....... x-y coordinate formula ..................
    getFinalX(xFromPsd) {
      return (xFromPsd/21) * 595.256
    },
    getFinalY(yFromPsd) {
      return ((29.7-yFromPsd)/29.7) * 841.8898
    },

    //submit form.
    submit() {
      this.overlay = true

      const db = getDatabase();
      const date = new Date();

      window.localStorage.setItem('eprop_agent_name', this.agentName)
      window.localStorage.setItem('eprop_agent_title', this.agentTitle)
      window.localStorage.setItem('eprop_agent_phone', this.agentPhoneNumber)
      window.localStorage.setItem('eprop_agent_email', this.agentEmail)
      window.localStorage.setItem('eprop_agent_image', this.uploadedImageUrl)

      push(ref(db, dbPaths.toEproposalProEss() + date.getFullYear() + '/' + date.getMonth() ), {
          agent_code: window.sessionStorage.getItem('agentCode').toUpperCase(),
          agent_name: this.agentName.toUpperCase(),
          client_name: this.clientName.toUpperCase(),
          date: date.toDateString(), 
          time: date.toLocaleTimeString(),
          objective: this.docObjective,
      })
      .then(() => {
          // Data saved successfully!
          
          this.generatePdf()
      })
      .catch((error) => {
          // The write failed...
          console.log(error);
          this.overlay = false
          this.overlayError = true
      });
    },

    //approved new method. 
    async generatePdf() {

      this.overlay = true

      this.progressValue = 10
      this.progressDetail = 'Initializing..'

      if(!this.docBen1) this.docBen1 = 'n/a'
      if(!this.docBen2) this.docBen2 = 'n/a'
      if(!this.docBen3) this.docBen3 = 'n/a'
      if(!this.docBen4) this.docBen4 = 'n/a'
      if(!this.docBen5) this.docBen5 = 'n/a'
      if(!this.docBen6) this.docBen6 = 'n/a'
      if(!this.docBen7) this.docBen7 = 'n/a'

      console.log('submit : start');

      const pdfByte1 = await fetch('pdf/proposal-1.pdf').then(res => res.arrayBuffer())
      const donorPdfDoc1 = await PDFDocument.load(pdfByte1)
      //console.log('test : page 1 loaded');

      const pdfByte3 = await fetch('pdf/proposal-3.pdf').then(res => res.arrayBuffer())
      const donorPdfDoc3 = await PDFDocument.load(pdfByte3)
      //console.log('test : page 3 loaded');

      const pdfByte4 = await fetch('pdf/proposal-takaful-pro-essential-4.pdf').then(res => res.arrayBuffer())
      const donorPdfDoc4 = await PDFDocument.load(pdfByte4)
      //console.log('test : page 4 loaded');

      const pdfByte5 = await fetch('pdf/proposal-takaful-pro-essential-5.pdf').then(res => res.arrayBuffer())
      const donorPdfDoc5 = await PDFDocument.load(pdfByte5)
      //console.log('test : page 5 loaded');

      const pdfByte6 = await fetch('pdf/proposal-6.pdf').then(res => res.arrayBuffer())
      const donorPdfDoc6 = await PDFDocument.load(pdfByte6)
      //console.log('test : page 6 loaded');
      
      const pdfDoc = await PDFDocument.create();

      const [DonorPage1] = await pdfDoc.copyPages(donorPdfDoc1, [0])
      const [DonorPage3] = await pdfDoc.copyPages(donorPdfDoc3, [0])
      const [DonorPage4] = await pdfDoc.copyPages(donorPdfDoc4, [0])
      const [DonorPage5] = await pdfDoc.copyPages(donorPdfDoc5, [0])
      const [DonorPage6] = await pdfDoc.copyPages(donorPdfDoc6, [0])

      this.progressValue = 20
      this.progressDetail = 'Preparing Page 1..'

      //input page 1
        const page1 = pdfDoc.addPage(DonorPage1)
        const fontPage1 = await pdfDoc.embedFont(StandardFonts.Helvetica)
        page1.drawText(this.clientName.toUpperCase(), {
          x: this.getFinalX(4.60),
          y: this.getFinalY(24.9),
          size: 22,
          font: fontPage1,
          color: rgb(1,1,1)
        })
        page1.drawText(this.agentName.toUpperCase(), {
          x: this.getFinalX(4.60),
          y: this.getFinalY(26.96),
          size: 20,
          font: fontPage1,
          color: rgb(1,1,1)
        })
        //console.log('test : page 1 added');
        this.progressValue = 30
        this.progressDetail = 'Preparing Page 2 - Drawing agent image'

      //input page 2
        const page2 = pdfDoc.addPage([page1.getWidth(), page1.getHeight()])
        //draw upload image
        //should put check if image has been cropped or not. imgFromLocalStorage(default image is used), imgCropped(new image is used)
        const pngUploadedImg = await pdfDoc.embedPng(this.uploadedImageUrl)
        page2.drawImage(pngUploadedImg, {
          x: 0,
          y: page2.getHeight()/2,
          width: page2.getWidth(),
          height: page2.getHeight()/2,
        })
        
        this.progressValue = 40
        this.progressDetail = 'Preparing Page 2 - Adding agent details'
        //draw about us image
        const pdfByte2 = await fetch(require('../assets/pdf/proposal-about-us-page.png')).then(res => res.arrayBuffer())
        const pngAboutUs = await pdfDoc.embedPng(pdfByte2)
        const pngDims = pngAboutUs.scaleToFit(page2.getWidth(), page2.getHeight())
        page2.drawImage(pngAboutUs, {
          x: 0,
          y: 0,
          width: pngDims.width,
          height: pngDims.height,
        })
        //add input
        const fontPage2 = await pdfDoc.embedFont(StandardFonts.Helvetica)
        page2.drawText(this.agentName.toUpperCase(), {
          x: this.getFinalX(1.78),
          y: this.getFinalY(10.15),
          size: 20,
          font: fontPage2,
          color: rgb(1,1,1)
        })
        page2.drawText(this.agentTitle.toUpperCase(), {
          x: this.getFinalX(1.78),
          y: this.getFinalY(10.88),
          size: 16,
          font: fontPage2,
          color: rgb(1,1,1)
        })
        page2.drawText(this.agentPhoneNumber + " - " + this.agentEmail, {
          x: this.getFinalX(5.20),
          y: this.getFinalY(26.72),
          size: 16,
          //font: fontPage2
        })
        //console.log('test : page 2 added');

      //input page 3
        this.progressValue = 50
        this.progressDetail = 'Preparing Page 3..'
        const page3 = pdfDoc.addPage(DonorPage3)
        page3.drawText(this.docObjective.toUpperCase(), {
          x: this.getFinalX(7.65),
          y: this.getFinalY(27.47),
          size: 14,
        })
        //console.log('test : page 3 added');

      //input page 4
        this.progressValue = 60
        this.progressDetail = 'Preparing Page 4..'
        const page4 = pdfDoc.addPage(DonorPage4)
        page4.drawText(this.clientName.toUpperCase(), {
          x: this.getFinalX(8.80),
          y: this.getFinalY(4.74),
          size: 10,
        })
        page4.drawText(this.clientGender.toUpperCase(), {
          x: this.getFinalX(8.80),
          y: this.getFinalY(5.15),
          size: 10,
        })
        page4.drawText(this.clientAge, {
          x: this.getFinalX(8.80),
          y: this.getFinalY(5.54),
          size: 10,
        })
        page4.drawText(this.clientIsSmoker.toUpperCase(), {
          x: this.getFinalX(8.80),
          y: this.getFinalY(5.92),
          size: 10,
        })
        
        page4.drawText(this.docTotalProtection, {
          x: this.getFinalX(9.50),
          y: this.getFinalY(7.12),
          size: 10,
        })
        page4.drawText(this.docTotalContributions, {
          x: this.getFinalX(9.50),
          y: this.getFinalY(7.52),
          size: 10,
        })
        page4.drawText(this.docPaymentMode.toUpperCase(), {
          x: this.getFinalX(8.94),
          y: this.getFinalY(7.95),
          size: 9,
        })
        page4.drawText(this.docProtectionPeriod, {
          x: this.getFinalX(8.94),
          y: this.getFinalY(8.36),
          size: 9,
        })
        
        page4.drawText(this.docBen1, {
          x: this.getFinalX(14.36),
          y: this.getFinalY(9.74),
          size: 10,
        })
        page4.drawText(this.docBen2, {
          x: this.getFinalX(14.36),
          y: this.getFinalY(10.06),
          size: 10,
        })
        page4.drawText(this.docBen3, {
          x: this.getFinalX(14.36),
          y: this.getFinalY(10.39),
          size: 10,
        })
        page4.drawText(this.docBen4, {
          x: this.getFinalX(14.36),
          y: this.getFinalY(10.74),
          size: 10,
        })
        page4.drawText(this.docBen5, {
          x: this.getFinalX(14.36),
          y: this.getFinalY(11.07),
          size: 10,
        })
        page4.drawText(this.docBen6, {
          x: this.getFinalX(14.36),
          y: this.getFinalY(11.42),
          size: 10,
        })
        page4.drawText(this.docBen7, {
          x: this.getFinalX(14.36),
          y: this.getFinalY(11.76),
          size: 10,
        })
        
        page4.drawText(this.docTotalProtection, {
          x: this.getFinalX(14.70),
          y: this.getFinalY(14.80),
          size: 11,
        })
        page4.drawText(this.docTotalProtection, {
          x: this.getFinalX(14.70),
          y: this.getFinalY(18.52),
          size: 11,
        })
        page4.drawText(this.docBen1, {
          x: this.getFinalX(14.70),
          y: this.getFinalY(22.00),
          size: 11,
        })
        page4.drawText(this.docTotalMature1, {
          x: this.getFinalX(13.92),
          y: this.getFinalY(24.61),
          size: 10,
        })
        page4.drawText(this.docTotalMature2, {
          x: this.getFinalX(13.92),
          y: this.getFinalY(24.98),
          size: 10,
        })
        //console.log('test : page 4 added');

      //input page 5
        this.progressValue = 70
        this.progressDetail = 'Preparing Page 5..'
        const page5 = pdfDoc.addPage(DonorPage5)
        page5.drawText(this.docBen1, {
          x: this.getFinalX(11.69),
          y: this.getFinalY(5.37),
          size: 10,
        })

        page5.drawText(this.clientAge, {
          x: this.getFinalX(5.95),
          y: this.getFinalY(7.22),
          size: 10,
        })
        page5.drawText(this.docProtectionPeriod, {
          x: this.getFinalX(2.55),
          y: this.getFinalY(9.09),
          size: 10,
        })
        
        page5.drawText(this.docBen5, {
          x: this.getFinalX(4.16),
          y: this.getFinalY(11.70),
          size: 10,
        })
        page5.drawText(this.docBen4, {
          x: this.getFinalX(5.62),
          y: this.getFinalY(12.17),
          size: 10,
        })
        page5.drawText(this.docBen3, {
          x: this.getFinalX(6.16),
          y: this.getFinalY(13.57),
          size: 10,
        })

        page5.drawText(this.docBen7, {
          x: this.getFinalX(3.87),
          y: this.getFinalY(16.82),
          size: 10,
        })
        page5.drawText(this.docBen6, {
          x: this.getFinalX(16.45),
          y: this.getFinalY(16.33),
          size: 10,
        })
        
        page5.drawText(this.docTotalProtection, {
          x: this.getFinalX(9.04),
          y: this.getFinalY(18.95),
          size: 10,
        })
        
        page5.drawText(this.docTotalMature1, {
          x: this.getFinalX(12.84),
          y: this.getFinalY(24.53),
          size: 10,
        })
        page5.drawText(this.docTotalMature2, {
          x: this.getFinalX(16.64),
          y: this.getFinalY(24.53),
          size: 10,
        })
        //console.log('test : page 5 added');

      //input page 6
        this.progressValue = 80
        this.progressDetail = 'Preparing Page 6..'
        pdfDoc.addPage(DonorPage6)
        //console.log('test : page 6 added');

      //console.log('test : pdf finish edit.');

      console.log('submit : pdf about to be generated');
      //generate and download.
      this.progressValue = 90
      this.progressDetail = 'Pdf finished..'
      const pdfBytes = await pdfDoc.save()
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Proposal-ProEssential-for-" + this.clientName + ".pdf";
      link.click();
      URL.revokeObjectURL(link.href);
      this.progressValue = 100
      this.progressDetail = 'Waiting for download..'

      //TEST DONE! ALL WORKED WELL!

    },
    

    //(experiment) get page details.
    async submit2() {
      const pdfDoc = await PDFDocument.load('proposalImages.proposalProEssential()')
      const pages = pdfDoc.getPages()
      const page1 = pages[0]

      console.log('width : ' + page1.getWidth());
      console.log('height : ' + page1.getHeight());

      //....... x-y coordinate formula ..................
      //const finalX = ( xFromPSD cm / 21 cm ) * 595.256
      //const finalY = ( ( 29.7 cm - yFromPSD cm ) / 29.7 cm ) * 841.8898

      //const finalX = (4.28/21) * 595.256
      //const finalY = ((29.7-21.54)/29.7) * 841.8898

      //console.log('finalX : ' + finalX);
      //console.log('finalY : ' + finalY);

      page1.drawText("Nama Klien", {
        x: this.getFinalX(4.28),
        y: this.getFinalY(21.54),
        size: 22,
        color: rgb(1,1,1)
      })

      //generate and download.
      const pdfBytes = await pdfDoc.save()
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Proposal-ProEssential-for-exp.pdf";
      link.click();
      URL.revokeObjectURL(link.href);
    },

    
    async submitOld() {
      /** 
      this.overlay = true

      if(!this.docBen1) this.docBen1 = 'n/a'
      if(!this.docBen2) this.docBen2 = 'n/a'
      if(!this.docBen3) this.docBen3 = 'n/a'
      if(!this.docBen4) this.docBen4 = 'n/a'
      if(!this.docBen5) this.docBen5 = 'n/a'
      if(!this.docBen6) this.docBen6 = 'n/a'
      if(!this.docBen7) this.docBen7 = 'n/a' 

      const pdfDoc = await PDFDocument.load(proposalImages.proposalProEssential())
      const pages = pdfDoc.getPages()

      //page1 input
        const page1 = pages[0]
        const fontPage1 = await pdfDoc.embedFont(StandardFonts.Helvetica)
        page1.drawText(this.clientName.toUpperCase(), {
          x: this.getFinalX(4.60),
          y: this.getFinalY(24.9),
          size: 22,
          font: fontPage1,
          color: rgb(1,1,1)
        })
        page1.drawText(this.agentName.toUpperCase(), {
          x: this.getFinalX(4.60),
          y: this.getFinalY(26.96),
          size: 20,
          font: fontPage1,
          color: rgb(1,1,1)
        })

      //page 2 input
        const page2 = pages[1]

        //draw page about us.
        const pngUploadedImg = await pdfDoc.embedPng(this.uploadedImageUrl)
        page2.drawImage(pngUploadedImg, {
          x: 0,
          y: page2.getHeight()/2,
          width: page2.getWidth(),
          height: page2.getHeight()/2,
        })

        //draw upload image
        const pngAboutUs = await pdfDoc.embedPng(proposalImages.aboutUsPage())
        const pngDims = pngAboutUs.scaleToFit(page2.getWidth(), page2.getHeight())
        page2.drawImage(pngAboutUs, {
          x: 0,
          y: 0,
          width: pngDims.width,
          height: pngDims.height,
        })

        const fontPage2 = await pdfDoc.embedFont(StandardFonts.Helvetica)
        page2.drawText(this.agentName.toUpperCase(), {
          x: this.getFinalX(1.78),
          y: this.getFinalY(10.15),
          size: 20,
          font: fontPage2,
          color: rgb(1,1,1)
        })
        page2.drawText(this.agentTitle.toUpperCase(), {
          x: this.getFinalX(1.78),
          y: this.getFinalY(10.88),
          size: 16,
          font: fontPage2,
          color: rgb(1,1,1)
        })
        page2.drawText(this.agentPhoneNumber + " - " + this.agentEmail, {
          x: this.getFinalX(5.20),
          y: this.getFinalY(26.72),
          size: 16,
          //font: fontPage2
        })

      //page3 input
        const page3 = pages[2]
        //const fontPage3 = await pdfDoc.embedFont(StandardFonts.TimesRomanBold)
        page3.drawText(this.docObjective.toUpperCase(), {
          x: this.getFinalX(7.65),
          y: this.getFinalY(27.47),
          size: 14,
          //font: fontPage3
        })

      //page4 input
        const page4 = pages[3]
        //const fontPage4 = await pdfDoc.embedFont(StandardFonts.TimesRoman)
        page4.drawText(this.clientName.toUpperCase(), {
          x: this.getFinalX(8.80),
          y: this.getFinalY(4.74),
          size: 10,
          //font: fontPage4
        })
        page4.drawText(this.clientGender.toUpperCase(), {
          x: this.getFinalX(8.80),
          y: this.getFinalY(5.15),
          size: 10,
          //font: fontPage4
        })
        page4.drawText(this.clientAge, {
          x: this.getFinalX(8.80),
          y: this.getFinalY(5.54),
          size: 10,
          //font: fontPage4
        })
        page4.drawText(this.clientIsSmoker.toUpperCase(), {
          x: this.getFinalX(8.80),
          y: this.getFinalY(5.92),
          size: 10,
          //font: fontPage4
        })
        
        page4.drawText(this.docTotalProtection, {
          x: this.getFinalX(9.50),
          y: this.getFinalY(7.12),
          size: 10,
          //font: fontPage4
        })
        page4.drawText(this.docTotalContributions, {
          x: this.getFinalX(9.50),
          y: this.getFinalY(7.52),
          size: 10,
          //font: fontPage4
        })
        page4.drawText(this.docPaymentMode.toUpperCase(), {
          x: this.getFinalX(8.94),
          y: this.getFinalY(7.95),
          size: 9,
          //font: fontPage4
        })
        page4.drawText(this.docProtectionPeriod, {
          x: this.getFinalX(8.94),
          y: this.getFinalY(8.36),
          size: 9,
          //font: fontPage4
        })
        
        page4.drawText(this.docBen1, {
          x: this.getFinalX(14.34),
          y: this.getFinalY(9.74),
          size: 10,
          //font: fontPage4
        })
        page4.drawText(this.docBen2, {
          x: this.getFinalX(14.34),
          y: this.getFinalY(10.06),
          size: 10,
          //font: fontPage4
        })
        page4.drawText(this.docBen3, {
          x: this.getFinalX(14.34),
          y: this.getFinalY(10.39),
          size: 10,
          //font: fontPage4
        })
        page4.drawText(this.docBen4, {
          x: this.getFinalX(14.34),
          y: this.getFinalY(10.74),
          size: 10,
          //font: fontPage4
        })
        page4.drawText(this.docBen5, {
          x: this.getFinalX(14.34),
          y: this.getFinalY(11.07),
          size: 10,
          //font: fontPage4
        })
        page4.drawText(this.docBen6, {
          x: this.getFinalX(14.34),
          y: this.getFinalY(11.42),
          size: 10,
          //font: fontPage4
        })
        page4.drawText(this.docBen7, {
          x: this.getFinalX(14.34),
          y: this.getFinalY(11.76),
          size: 10,
          //font: fontPage4
        })
        
        page4.drawText(this.docTotalProtection, {
          x: this.getFinalX(14.70),
          y: this.getFinalY(14.80),
          size: 11,
          //font: fontPage4
        })
        page4.drawText(this.docTotalProtection, {
          x: this.getFinalX(14.70),
          y: this.getFinalY(18.52),
          size: 11,
          //font: fontPage4
        })
        page4.drawText(this.docBen1, {
          x: this.getFinalX(14.70),
          y: this.getFinalY(22.00),
          size: 11,
        })
        page4.drawText(this.docTotalMature1, {
          x: this.getFinalX(13.92),
          y: this.getFinalY(24.61),
          size: 10,
          //font: fontPage4
        })
        page4.drawText(this.docTotalMature2, {
          x: this.getFinalX(13.92),
          y: this.getFinalY(24.98),
          size: 10,
          //font: fontPage4
        })

      //page5 input
        const page5 = pages[4]
        //const fontPage5 = await pdfDoc.embedFont(StandardFonts.TimesRomanBoldItalic)
        page5.drawText(this.docBen1, {
          x: this.getFinalX(11.69),
          y: this.getFinalY(5.37),
          size: 10,
          //font: fontPage5
        })

        page5.drawText(this.clientAge, {
          x: this.getFinalX(5.95),
          y: this.getFinalY(7.22),
          size: 10,
          //font: fontPage5
        })
        page5.drawText(this.docProtectionPeriod, {
          x: this.getFinalX(2.55),
          y: this.getFinalY(9.09),
          size: 10,
          //font: fontPage5
        })
        
        page5.drawText(this.docBen5, {
          x: this.getFinalX(4.16),
          y: this.getFinalY(11.70),
          size: 10,
          //font: fontPage5
        })
        page5.drawText(this.docBen4, {
          x: this.getFinalX(5.62),
          y: this.getFinalY(12.17),
          size: 10,
          //font: fontPage5
        })
        page5.drawText(this.docBen3, {
          x: this.getFinalX(6.16),
          y: this.getFinalY(13.57),
          size: 10,
          //font: fontPage5
        })
        
        page5.drawText(this.docBen7, {
          x: this.getFinalX(3.87),
          y: this.getFinalY(16.82),
          size: 10,
          //font: fontPage5
        })
        page5.drawText(this.docBen6, {
          x: this.getFinalX(16.45),
          y: this.getFinalY(16.33),
          size: 10,
          //font: fontPage5
        })
        
        page5.drawText(this.docTotalProtection, {
          x: this.getFinalX(9.04),
          y: this.getFinalY(18.95),
          size: 10,
          //font: fontPage5
        })
        
        page5.drawText(this.docTotalMature1, {
          x: this.getFinalX(12.84),
          y: this.getFinalY(24.53),
          size: 10,
          //font: fontPage5
        })
        page5.drawText(this.docTotalMature2, {
          x: this.getFinalX(16.64),
          y: this.getFinalY(24.53),
          size: 10,
          //font: fontPage5
        })
     
      //generate and download.
        const pdfBytes = await pdfDoc.save()
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Proposal-ProEssential-for-" + this.clientName + ".pdf";
        link.click();
        URL.revokeObjectURL(link.href);
      */
    },

  },

  mounted() {
    this.agentName = window.localStorage.getItem('eprop_agent_name')
    this.agentTitle = window.localStorage.getItem('eprop_agent_title')
    this.agentPhoneNumber = window.localStorage.getItem('eprop_agent_phone')
    this.agentEmail = window.localStorage.getItem('eprop_agent_email')
    this.uploadedImgFromLocalStorage = window.localStorage.getItem('eprop_agent_image')
    this.uploadedImageUrl = this.uploadedImgFromLocalStorage

    this.isImgFromLocalStorage = (window.localStorage.getItem('eprop_agent_image'))? true : false

    //make default image if the new added image is cleared.

  }

}
</script>

<style lang="scss">
.text-input input{
  text-transform: uppercase
}
</style>